import { Button, Table } from "antd";
import { useFetchInventoryQuery, useFetchJobcardsQuery } from "features/store";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import styled from "styled-components";
import api from "utils/api";

const InvenReport = () => {
  // Fetch with maximum page_size to get as much data as possible
  const { data: firstPageData, isLoading: loading } = useFetchInventoryQuery({
    page: 1,
    page_size: 100, // Maximum allowed page size
  });
  
  const [allInventoryData, setAllInventoryData] = useState([]);
  const [isFetchingAll, setIsFetchingAll] = useState(false);
  //   console.log(
  //     cards?.filter((item) => item.current_stage === "completed").map((s) => s)
  //   );
  const headers = [
    { label: "Sr No.", key: "id" },
    { label: "Material Type", key: "color_cloth.material_type" },
    { label: "Cap Material", key: "color_cloth.cap_material" },
    { label: "Type", key: "color_cloth.type" },
    { label: "Cloth Type", key: "color_cloth.cloth_type" },
    { label: "Color", key: "color_cloth.color" },
    { label: "Available Quantity", key: "quantity" },
  ];
  const [completed, setCompleted] = useState([]);
  const [colth_type, setcolth_type] = useState([]);
  const [ultimate, setultimate] = useState([]);

  // Fetch all pages when first page data is available
  useEffect(() => {
    const fetchAllInventoryPages = async () => {
      if (!firstPageData || isFetchingAll || allInventoryData.length > 0) return;

      setIsFetchingAll(true);
      try {
        const allResults = [];
        
        // Handle paginated response structure
        const isPaginated = firstPageData?.results !== undefined;
        
        if (isPaginated) {
          // Add first page results
          allResults.push(...(firstPageData.results || []));
          
          const totalCount = firstPageData.count || 0;
          const pageSize = 100; // Maximum page size
          const totalPages = Math.ceil(totalCount / pageSize);
          
          // Fetch remaining pages if any
          if (totalPages > 1) {
            const fetchPromises = [];
            for (let page = 2; page <= totalPages; page++) {
              fetchPromises.push(
                api.get("/inventory/list/", {
                  params: { page, page_size: pageSize },
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("userToken")}`,
                    Accept: "application/json",
                  },
                })
              );
            }
            
            const responses = await Promise.all(fetchPromises);
            responses.forEach((response) => {
              if (response.data?.results) {
                allResults.push(...response.data.results);
              }
            });
          }
        } else {
          // Non-paginated response (array)
          allResults.push(...(Array.isArray(firstPageData) ? firstPageData : []));
        }
        
        setAllInventoryData(allResults);
      } catch (error) {
        console.error("Error fetching all inventory pages:", error);
        // Fallback to first page data if fetching all pages fails
        const fallbackData = Array.isArray(firstPageData) 
          ? firstPageData 
          : (firstPageData?.results || []);
        setAllInventoryData(fallbackData);
      } finally {
        setIsFetchingAll(false);
      }
    };

    fetchAllInventoryPages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstPageData]);

  const getReportarray = () => {
    const result = [];

    // Use allInventoryData instead of cards
    const cardsArray = allInventoryData;
    
    if (!Array.isArray(cardsArray)) {
      console.error("cards is not an array:", cardsArray);
      return;
    }

    cardsArray.forEach((item) => {
      const { color_cloth, inventory_quantity } = item;
      if (!color_cloth) return;
      
      const { color, cloth_type, material_type, cap_material, type } =
        color_cloth;

      // Ensure inventory_quantity is an array
      const inventoryArray = Array.isArray(inventory_quantity) ? inventory_quantity : [];
      
      inventoryArray.forEach((inventoryItem) => {
        const { quantity, rate, created_at } = inventoryItem;

        const transformedItem = {
          color,
          cloth_type,
          material_type,
          quantity,
          rate,
          created_at,
          cap_material,
          type,
        };

        result.push(transformedItem);
      });
    });

    const uniqueClothTypes = [
      ...new Set(result.map((item) => item?.cloth_type)),
    ];
    console.log(
      uniqueClothTypes.filter((yo) => yo !== null),
      "unique"
    );
    setcolth_type(uniqueClothTypes.filter((yo) => yo !== null));
    console.log(
      uniqueClothTypes
        .filter((yo) => yo !== null)
        .map((op) => result?.filter((it) => it.cloth_type === op))
    );
    setultimate(
      uniqueClothTypes
        .filter((yo) => yo !== null)
        .map((op) => result?.filter((it) => it.cloth_type === op))
    );
    console.log(result);
    setCompleted(result);
    console.log("comp", completed);
  };
  useEffect(() => {
    if (allInventoryData.length > 0) {
      getReportarray();
    }
  }, [allInventoryData]);
  
  // Use allInventoryData for display
  const cardsArray = allInventoryData;
  // const completed =cards?.filter((item)=>item.current_stage==="completed").map((s)=>s)
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "index",
      width: "15%",
      render: (text, record, index) => index + 1,
      // sorter: (a, b) => parseInt(a.id) - parseInt(b.id),
    },

    {
      title: "Color",
      dataIndex: "color",
    },
    {
      title: "Rate",
      dataIndex: "rate",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: "15%",
      editable: true,
    },
    {
      title: "Created At",
      dataIndex: "created_at",

      editable: true,
      render: (text) => {
        if (text && moment(text).isValid()) {
          return moment(text).format("YYYY-MM-DD");
        }
        return "N/A";
      },
    },
  ];
  return (
    <>
      {(loading || isFetchingAll) ? (
        <p>loading</p>
      ) : (
        <>
          <h1
            style={{
              margin: "30px 0px",
              textAlign: "center",
              fontWeight: "600",
              color: "#00afe2",
              padding: "10px",
            }}
          >
            Inventory Report
          </h1>

          <div style={{ width: "90%", margin: "auto" }}>
            <Button style={{ margin: "3rem" }}>
              {" "}
              <CSVLink
                className="export_to_excel"
                data={cardsArray.map((card) => {
                  return {
                    ...card,
                  };
                })}
                headers={headers}
                filename={"versatileapparels.csv"}
              >
                Export To Excel Available Quantity
              </CSVLink>
            </Button>
            <Button style={{ margin: "3rem" }}>
              {" "}
              <CSVLink
                className="export_to_excel"
                data={Array.isArray(completed) ? completed.map((card) => {
                  return {
                    ...card
                  };
                }) : []}
                // headers={headers}

                filename={"versatileapparels.csv"}
              >
                Export To Excel Inventory
              </CSVLink>
            </Button>
            <Style
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-around",
              }}
            >
              {colth_type?.map((item, index) => (
                <div key={index} style={{ width: "40%" }}>
                  <h2
                    style={{
                      background: "#00afe2",
                      color: "white",
                      padding: "10px",
                    }}
                  >
                    {item}
                  </h2>
                  <Table
                    bordered
                    dataSource={completed?.filter(
                      (it) => it.cloth_type === item
                    )}
                    columns={columns}
                    rowClassName="editable-row"
                    className="my-table"
                    //   pagination={{
                    //     onChange: cancel,
                    //   }}
                  />
                </div>
              ))}
              {/* <Table
            bordered
            dataSource={completed}
            columns={columns}
            rowClassName="editable-row"
            className="my-table"
            //   pagination={{
            //     onChange: cancel,
            //   }}
          /> */}
            </Style>
          </div>
        </>
      )}
    </>
  );
};

export default InvenReport;

const Style = styled.div`
  .my-table {
    font-size: 16px;
  }

  .my-table .ant-table-header {
    background-color: var(--color-table-head);
  }

  .my-table .ant-table-thead > tr > th {
    background-color: var(--color-table-head);
    border: 0.1px solid #d9d9d9;
    font-weight: 500;
    font-size: 1.2rem;
  }

  .my-table .ant-table-tbody > tr > td {
    border: 0.2px solid #ebebeb;
  }
`;
